import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import AddVehicle from 'src/components/AddVehicle/AddVehicle';
import { AppointmentActionCreator, FrameworkActionCreator, NewVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    custInfo: state.Customer.Customer,
    newVehicleInfo: state.NewVehicle.NewVehicle,
    vehicleSpecs: state.Specs.specs,
    leftPaneViewOrder: state.Framework.leftPaneViewOrder,
    selectedVehicle: state.Appointment.ApptVeh,
    prevMileage: state.Vehicles.selectedVehicle !== 'AddVehicle' &&
        state.Vehicles.selectedVehicle !== '' && state.Vehicles && state.Vehicles.vehicles[state.Vehicles.selectedVehicle!] ?
        state.Vehicles.vehicles[state.Vehicles.selectedVehicle!].prevMileage : 0,
    apptCust: state.Appointment.ApptCust,
    sameFirstNames: state.Customer.sameFirstNames ?? false,
    currentProperty: state.NewVehicle.CurrentProperty,
    addVehicle: state.Vehicles.selectedVehicle === 'AddVehicle' ? true : false,
    theme: state.Framework.theme,
    defaultLen: state.Specs.specs?.validMakes.length ?? 0,
    multipleCustomers: state.Customer.multipleCustomers ?? false,
    rdwModels: state.RDWVehicle.models,
    Itype: state.Framework.ImageServerType,
    TMNAMileage: state.AdditionalServices.maintContractData.TMNAMileage,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    onAddNewVehicle: NewVehicleActionCreator.AddNewVehicle,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    updateVehicleMileage: AppointmentActionCreator.UpdateApptVehicleMileage,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddVehicle);